<template>
  <el-container>
    <el-header height="100%" class="ph0">
      <order-detail-header
        :order="order"
        :currentStatus="orderDetail.currentStatus"
        @searchOrder="searchOrder"
      />
    </el-header>
    <el-main class="ph4">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-collapse
            v-for="(shipment, index) in order.shipments"
            :key="index"
            class="collapse mb3"
            v-model="activeNames"
          >
            <el-collapse-item :name="getOrder(shipment.shipmentNo, index)">
              <template slot="title">
                <div class="container-title mb2">
                  <b class="f5">{{ shipment.shipmentNo }}</b>
                  <el-button
                    @click="getOrder(shipment.shipmentNo, index)"
                    class="btn-warning"
                    type="warning"
                    >{{
                      $_strings.order.getStatusText(shipment.status)
                    }}</el-button
                  >
                </div>
              </template>
              <el-col :span="8">
                <detail :order="listOrder[index]" />
              </el-col>
              <el-col :span="8">
                <status
                  v-if="listOrder[index]"
                  :statusUpdates="listOrder[index].statusHistory"
                  :vehicleLocation="listOrder[index]"
                />
              </el-col>
              <el-col v-if="listOrder[index]" class="text-left" :span="8">
                <b class="text-left f5">Pelacakan Pesanan</b>
                <el-divider></el-divider>
                <GmapMap
                  v-loading="mapLoading"
                  ref="map"
                  :center="{ lat: -6.308017275823, lng: 106.852580721527 }"
                  :zoom="12"
                  map-type-id="terrain"
                  class="w-100 h5"
                  :options="{
                    zoomControl: true,
                    mapTypeControl: true,
                    scaleControl: true,
                    streetViewControl: true,
                    rotateControl: true,
                    fullscreenControl: true,
                  }"
                >
                  <GmapMarker
                    v-if="vehicleLocation !== null"
                    :position="vehicleLocation(index)"
                    :clickable="true"
                    :icon="{
                      url: require('@/assets/images/yellow-map-marker-icon.png'),
                    }"
                  />
                  <GmapMarker
                    :position="listOrder[index].originCoordinate"
                    :clickable="true"
                    :icon="{
                      url: require('@/assets/images/icon-origin-map.png'),
                    }"
                  />
                  <GmapMarker
                    :position="listOrder[index].destinationCoordinate"
                    :clickable="true"
                    :icon="{
                      url: require('@/assets/images/icon-destination-map.png'),
                    }"
                  />
                </GmapMap>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import Header from "../components/OrderDetail/Header";
import Detail from "../components/OrderDetail/Detail";
import Status from "../components/OrderDetail/Status";

export default {
  name: "order-detail",
  components: {
    "order-detail-header": Header,
    Detail,
    Status,
  },
  props: ["order"],
  computed: {
    // vehicleLocation: function (index) {
    //   if (this.listOrder[index].vehicleLocation === null) {
    //     return null
    //   } else {
    //     return this.listOrder[index].vehicleLocation
    //   }
    // },
  },

  data() {
    return {
      activeNames: [],
      orderDetail: {},
      listOrder: [],
      mapLoading: true,
    };
  },
  methods: {
    fetchOrderDetail(id) {
      let loadingInstance = this.$loading();
      this.$_services.orderByShipment
        .searchOrder(id)
        .then((result) => {
          console.log("TCL: fetchOrderDetail -> result", result);
          if(result.data === null){
            return this.$message.error("Nomor Pesanan tidak ditemukan");
          }
          this.$set(this, "order", result.data);
        })
        .catch((err) => {
          console.log("TCL: fetchOrderDetail -> err", err.response);
          if (err.response.status === 404) {
            this.$message.error("Nomor Pesanan tidak ditemukan");
            this.$router.push("/main/dashboard");
          }
        })
        .finally((e) => {
          loadingInstance.close();
        });
    },
    searchOrder: async function (value) {
      let loadingInstance = this.$loading();
      // this.$_services.order
      this.$_services.orderByShipment
        .searchOrder(value)
        .then((result) => {
          console.log("TCL: fetchOrderTrackingDetail -> result", result);
          if (result.data == null) {
            this.$message.error("Nomor Pesanan tidak ditemukan");
            this.$router.push("/main/dashboard");
          }
          this.$set(this, "orderDetail", result.data);
        })
        .catch((err) => {
          console.log("TCL: fetchOrderTrackingDetail -> err", err);
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        })
        .finally((e) => {
          loadingInstance.close();
          setTimeout(() => {
            this.mapLoading = false;
            this.pinToBound(
              this.orderDetail.originCoordinate,
              this.orderDetail.destinationCoordinate
            );
          }, 2000);
        });
    },
    pinToBound: function (location1, location2) {
      /* eslint-disable */
      var b = new google.maps.LatLngBounds();
      /* eslint-enable */

      b.extend({
        lat: location1.lat,
        lng: location1.lng,
      });

      b.extend({
        lat: location2.lat,
        lng: location2.lng,
      });
      this.$refs.map.fitBounds(b, 25);
      this.mapLoading = false;
    },
    getOrder(value, index) {
      if (!this.listOrder[index]) {
        let loadingInstance = this.$loading();
        this.$_services.order
          .searchOrder(value)
          .then((result) => {
            console.log("TCL: fetchOrderTrackingDetail -> result", result);
            this.listOrder.push(result.data);
            console.log("listorder", this.listOrder);
          })
          .catch((err) => {
            console.log("TCL: fetchOrderTrackingDetail -> err", err);
            setTimeout(() => {
              this.$router.go(-1);
            }, 1000);
          })
          .finally((e) => {
            loadingInstance.close();
            setTimeout(() => {
              this.mapLoading = false;
              this.pinToBound(
                this.orderDetail.originCoordinate,
                this.orderDetail.destinationCoordinate
              );
            }, 2000);
          });
      }
    },
    vehicleLocation: function (index) {
      if (this.listOrder[index].vehicleLocation === null) {
        return null;
      } else {
        return this.listOrder[index].vehicleLocation;
      }
    },
  },
  async created() {
    if (this.order === undefined) {
      this.fetchOrderDetail(this.$route.params.orderNo);
    }
  },
  async mounted() {
    if (this.order !== undefined) {
      this.orderDetail = this.order;
      console.log(this.orderDetail.statusHistory[6].status);
      setTimeout(() => {
        this.mapLoading = false;
        this.pinToBound(
          this.orderDetail.originCoordinate,
          this.orderDetail.destinationCoordinate
        );
      }, 2000);
    }
  },
  watch: {
    "$route.params.orderNo": function (id) {
      this.fetchOrderDetail(id);
      this.listOrder = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.container-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .btn-warning {
    max-width: 150px;
    white-space: initial;
  }
}
.el-collapse.collapse {
  border-top: 0;
}
</style>
